<template>
  <section>
    <cursoHeader title="">
    </cursoHeader>
    <div class="flex flex-row flex-wrap">
      <div
        class="col-12 sm-col-6 p1 flex flex-column"
        v-for="record in $dados.BLOCOS"
        :key="record.ID"
      >
        <div class="flex-auto flex flex-column p1 bg-white border border-gray">
          <h2 class="m1">{{record.NOME}}</h2>
          <div class="flex-auto"></div>
          <div class="flex flex-row flex-wrap">
            <span
              class="btn btn-primary m1 col-12 md-col-auto"
              v-show="page.name != 'MODULOS'"
              v-for="page in $dados.pages"
              :key="page.url"
              @click="goto(page, record.ID)"
            >
              {{page.title}}
            </span>
          </div>
        </div>
        {{record.ID}}
      </div>
    </div>
  </section>
</template>

<script>
import cursoHeader from '@/custom/cursoHeader'
var componentDefinition = {
  components: { cursoHeader },
  route: {
    name: 'MODULOS',
    path: '/aluno/:idaluno/matricula/:idmatricula/',
    meta: {
      title: 'Módulos'
    }
  },
  methods: {
    goto: function (page, idbloco) {
      var params = this.$route.params
      params.idbloco = idbloco
      var route = {
        name: page.name,
        params: params
      }
      this.$router.push(route)
    }
  }
}
export default componentDefinition
</script>
